
import { macroCondition, getGlobalConfig } from '@embroider/macros';


import defineModule0 from "./-embroider-implicit-modules.js";

import * as amdModule0 from "./adapters/application.ts"
import * as amdModule1 from "./app.ts"
import * as amdModule2 from "./config/abilities.ts"
import * as amdModule3 from "./config/environment.ts"
import * as amdModule4 from "./data/async-setter.ts"
import * as amdModule5 from "./data/builders/content/contacts.ts"
import * as amdModule6 from "./data/builders/content/files.ts"
import * as amdModule7 from "./data/builders/content/folders.ts"
import * as amdModule8 from "./data/builders/content/media-images.ts"
import * as amdModule9 from "./data/builders/content/pages.ts"
import * as amdModule10 from "./data/builders/content/quizzes.ts"
import * as amdModule11 from "./data/builders/content/reading-lists.ts"
import * as amdModule12 from "./data/builders/content/resources.ts"
import * as amdModule13 from "./data/builders/content/sections.ts"
import * as amdModule14 from "./data/builders/quiz/pages.ts"
import * as amdModule15 from "./data/builders/system/clients.ts"
import * as amdModule16 from "./data/builders/system/feeds.ts"
import * as amdModule17 from "./data/builders/system/homes.ts"
import * as amdModule18 from "./data/builders/system/picklist-items.ts"
import * as amdModule19 from "./data/builders/system/user-groups.ts"
import * as amdModule20 from "./data/builders/system/users.ts"
import * as amdModule21 from "./data/builders/system/xapi.ts"
import * as amdModule22 from "./data/builders/xceed/calendar-items.ts"
import * as amdModule23 from "./data/builders/xceed/cohorts.ts"
import * as amdModule24 from "./data/builders/xceed/messages.ts"
import * as amdModule25 from "./data/builders/xceed/modules.ts"
import * as amdModule26 from "./data/builders/xceed/programs.ts"
import * as amdModule27 from "./data/deep-has-changed.ts"
import * as amdModule28 from "./data/deep-rollback.ts"
import * as amdModule29 from "./data/deep-save.ts"
import * as amdModule30 from "./data/handlers/auth-handler.ts"
import * as amdModule31 from "./data/handlers/debug-handler.ts"
import * as amdModule32 from "./data/handlers/type-normalizer-handler.ts"
import * as amdModule33 from "./data/json-api.ts"
import * as amdModule34 from "./data/normalizers/jsonapi-document.ts"
import * as amdModule35 from "./data/normalizers/jsonapi-normalizer.ts"
import * as amdModule36 from "./data/normalizers/text.ts"
import * as amdModule37 from "./data/normalizers/url-normalizer.ts"
import * as amdModule38 from "./deprecation-workflow.ts"
import * as amdModule39 from "./lib/color.ts"
import * as amdModule40 from "./lib/file-icon.ts"
import * as amdModule41 from "./lib/json-api.ts"
import * as amdModule42 from "./lib/markdown-toolbar.ts"
import * as amdModule43 from "./lib/media/media-image-info.ts"
import * as amdModule44 from "./lib/media/media-image-key.ts"
import * as amdModule45 from "./lib/media/media-image-path.ts"
import * as amdModule46 from "./lib/media/models.ts"
import * as amdModule47 from "./lib/media/paths.ts"
import * as amdModule48 from "./lib/media/sizes.ts"
import * as amdModule49 from "./lib/page-manager.ts"
import * as amdModule50 from "./lib/random-slug.ts"
import * as amdModule51 from "./lib/type-utils.ts"
import * as amdModule52 from "./resources/string-array.ts"
import * as amdModule53 from "./router.ts"
import * as amdModule54 from "./serializers/application.ts"
import * as amdModule55 from "./services/ability.ts"
import * as amdModule56 from "./services/media-images.ts"
import * as amdModule57 from "./services/session.ts"
import * as amdModule58 from "./services/store.ts"
import * as amdModule59 from "./services/va-config.ts"
import * as amdModule60 from "./services/xapi.ts"
import * as amdModule61 from "./utils/array.ts"
import * as amdModule62 from "./utils/files.ts"
import * as amdModule63 from "./utils/mark-answer.ts"
import * as amdModule64 from "./utils/random-answer.ts"
import * as amdModule65 from "./utils/random-values.ts"
import * as amdModule66 from "./utils/user-groups.ts"
import * as amdModule67 from "./utils/words.ts"
import * as amdModule68 from "./initializers/load-bootstrap-config.js"
import * as amdModule69 from "./instance-initializers/global-ref-cleanup.js"
import * as amdModule70 from "./services/-ensure-registered.js"
import * as amdModule71 from "./instance-initializers/gtm.js"
import * as amdModule72 from "./services/gtm.js"
import * as amdModule73 from "./utils/gtm-page-views.js"
import * as amdModule74 from "./utils/gtm-sluggify.js"
import * as amdModule75 from "./utils/gtm.js"
import * as amdModule76 from "./services/page-title.js"
import * as amdModule77 from "./initializers/ember-data.js"
import * as amdModule78 from "./transforms/date.js"
import * as amdModule79 from "./transforms/number.js"
import * as amdModule80 from "./transforms/string.js"
import * as amdModule81 from "./transforms/boolean.js"
import * as amdModule82 from "./data-adapter.js"
import * as amdModule83 from "./services/customization.js"
import * as amdModule84 from "./services/picklists.js"
import * as amdModule85 from "./services/remote-file.js"
import * as amdModule86 from "./services/restrictions.js"
import * as amdModule87 from "./templates/application.gts"
import * as amdModule88 from "./routes/application.ts"
import * as amdModule89 from "./routes/library/clients/client.ts"
import * as amdModule90 from "./templates/library/clients/client/edit.gts"
import * as amdModule91 from "./routes/library/clients/client/edit.ts"
import * as amdModule92 from "./templates/library/clients/client/edit/branding.gts"
import * as amdModule93 from "./routes/library/clients/client/edit/branding.ts"
import * as amdModule94 from "./templates/library/clients/client/edit/content.gts"
import * as amdModule95 from "./routes/library/clients/client/edit/content.ts"
import * as amdModule96 from "./routes/library/clients/client/edit/feeds.ts"
import * as amdModule97 from "./templates/library/clients/client/edit/files.gts"
import * as amdModule98 from "./routes/library/clients/client/edit/files.ts"
import * as amdModule99 from "./templates/library/clients/client/edit/general.gts"
import * as amdModule100 from "./routes/library/clients/client/edit/general.ts"
import * as amdModule101 from "./templates/library/clients/client/edit/home.gts"
import * as amdModule102 from "./routes/library/clients/client/edit/home.ts"
import * as amdModule103 from "./routes/library/clients/client/edit/index.ts"
import * as amdModule104 from "./routes/library/clients/client/edit/user-groups.ts"
import * as amdModule105 from "./templates/library/clients/client/edit/users.gts"
import * as amdModule106 from "./routes/library/clients/client/edit/users.ts"
import * as amdModule107 from "./templates/library/clients/client/edit/xapi.gts"
import * as amdModule108 from "./routes/library/clients/client/edit/xapi.ts"
import * as amdModule109 from "./templates/library/clients/erase.gts"
import * as amdModule110 from "./routes/library/clients/erase.ts"
import * as amdModule111 from "./templates/library/clients/import-users.gts"
import * as amdModule112 from "./routes/library/clients/import-users.ts"
import * as amdModule113 from "./templates/library/clients/index.gts"
import * as amdModule114 from "./templates/library/folders.gts"
import * as amdModule115 from "./routes/library/folders.ts"
import * as amdModule116 from "./templates/library/folders/file.gts"
import * as amdModule117 from "./routes/library/folders/file.ts"
import * as amdModule118 from "./templates/library/folders/new.gts"
import * as amdModule119 from "./routes/library/folders/new.ts"
import * as amdModule120 from "./templates/library/folders/upload.gts"
import * as amdModule121 from "./routes/library/folders/upload.ts"
import * as amdModule122 from "./templates/library/folders/index.gts"
import * as amdModule123 from "./templates/library/media-images/edit.gts"
import * as amdModule124 from "./routes/library/media-images/edit.ts"
import * as amdModule125 from "./templates/library/media-images/index.gts"
import * as amdModule126 from "./templates/library/media-images/upload.gts"
import * as amdModule127 from "./routes/programs/program.ts"
import * as amdModule128 from "./templates/programs/program/cohort.gts"
import * as amdModule129 from "./routes/programs/program/cohort.ts"
import * as amdModule130 from "./templates/programs/program/cohort/calendar/calendar-item.gts"
import * as amdModule131 from "./routes/programs/program/cohort/calendar/calendar-item.ts"
import * as amdModule132 from "./templates/programs/program/cohort/calendar/index.gts"
import * as amdModule133 from "./templates/programs/program/cohort/content.gts"
import * as amdModule134 from "./routes/programs/program/cohort/content/module.ts"
import * as amdModule135 from "./templates/programs/program/cohort/content/module/page.gts"
import * as amdModule136 from "./routes/programs/program/cohort/content/module/page.ts"
import * as amdModule137 from "./routes/programs/program/cohort/content/module/quiz.ts"
import * as amdModule138 from "./templates/programs/program/cohort/content/module/index.gts"
import * as amdModule139 from "./templates/programs/program/cohort/content/page.gts"
import * as amdModule140 from "./routes/programs/program/cohort/content/page.ts"
import * as amdModule141 from "./templates/programs/program/cohort/content/quiz.gts"
import * as amdModule142 from "./routes/programs/program/cohort/content/quiz.ts"
import * as amdModule143 from "./templates/programs/program/cohort/content/index.gts"
import * as amdModule144 from "./routes/programs/program/cohort/messages.ts"
import * as amdModule145 from "./routes/programs/program/cohort/messages/category.ts"
import * as amdModule146 from "./templates/programs/program/cohort/messages/category/message.gts"
import * as amdModule147 from "./routes/programs/program/cohort/messages/category/message.ts"
import * as amdModule148 from "./templates/programs/program/cohort/messages/category/new.gts"
import * as amdModule149 from "./routes/programs/program/cohort/messages/category/new.ts"
import * as amdModule150 from "./templates/programs/program/cohort/messages/category/index.gts"
import * as amdModule151 from "./routes/programs/program/cohort/messages/index.ts"
import * as amdModule152 from "./templates/programs/program/cohort/participants.gts"
import * as amdModule153 from "./routes/programs/program/cohort/participants.ts"
import * as amdModule154 from "./templates/programs/program/cohort/index.gts"
import * as amdModule155 from "./templates/programs/program/index.gts"
import * as amdModule156 from "./templates/programs/index.gts"
import * as amdModule157 from "./templates/bootstrap.gts"
import * as amdModule158 from "./templates/index.gts"
import * as amdModule159 from "./templates/resource.gts"

let exportFastbootModules = {};





export default Object.assign(
  {},
defineModule0,
  {
"@efdigital/ll-admin-v2/adapters/application": amdModule0,
"@efdigital/ll-admin-v2/app": amdModule1,
"@efdigital/ll-admin-v2/config/abilities": amdModule2,
"@efdigital/ll-admin-v2/config/environment": amdModule3,
"@efdigital/ll-admin-v2/data/async-setter": amdModule4,
"@efdigital/ll-admin-v2/data/builders/content/contacts": amdModule5,
"@efdigital/ll-admin-v2/data/builders/content/files": amdModule6,
"@efdigital/ll-admin-v2/data/builders/content/folders": amdModule7,
"@efdigital/ll-admin-v2/data/builders/content/media-images": amdModule8,
"@efdigital/ll-admin-v2/data/builders/content/pages": amdModule9,
"@efdigital/ll-admin-v2/data/builders/content/quizzes": amdModule10,
"@efdigital/ll-admin-v2/data/builders/content/reading-lists": amdModule11,
"@efdigital/ll-admin-v2/data/builders/content/resources": amdModule12,
"@efdigital/ll-admin-v2/data/builders/content/sections": amdModule13,
"@efdigital/ll-admin-v2/data/builders/quiz/pages": amdModule14,
"@efdigital/ll-admin-v2/data/builders/system/clients": amdModule15,
"@efdigital/ll-admin-v2/data/builders/system/feeds": amdModule16,
"@efdigital/ll-admin-v2/data/builders/system/homes": amdModule17,
"@efdigital/ll-admin-v2/data/builders/system/picklist-items": amdModule18,
"@efdigital/ll-admin-v2/data/builders/system/user-groups": amdModule19,
"@efdigital/ll-admin-v2/data/builders/system/users": amdModule20,
"@efdigital/ll-admin-v2/data/builders/system/xapi": amdModule21,
"@efdigital/ll-admin-v2/data/builders/xceed/calendar-items": amdModule22,
"@efdigital/ll-admin-v2/data/builders/xceed/cohorts": amdModule23,
"@efdigital/ll-admin-v2/data/builders/xceed/messages": amdModule24,
"@efdigital/ll-admin-v2/data/builders/xceed/modules": amdModule25,
"@efdigital/ll-admin-v2/data/builders/xceed/programs": amdModule26,
"@efdigital/ll-admin-v2/data/deep-has-changed": amdModule27,
"@efdigital/ll-admin-v2/data/deep-rollback": amdModule28,
"@efdigital/ll-admin-v2/data/deep-save": amdModule29,
"@efdigital/ll-admin-v2/data/handlers/auth-handler": amdModule30,
"@efdigital/ll-admin-v2/data/handlers/debug-handler": amdModule31,
"@efdigital/ll-admin-v2/data/handlers/type-normalizer-handler": amdModule32,
"@efdigital/ll-admin-v2/data/json-api": amdModule33,
"@efdigital/ll-admin-v2/data/normalizers/jsonapi-document": amdModule34,
"@efdigital/ll-admin-v2/data/normalizers/jsonapi-normalizer": amdModule35,
"@efdigital/ll-admin-v2/data/normalizers/text": amdModule36,
"@efdigital/ll-admin-v2/data/normalizers/url-normalizer": amdModule37,
"@efdigital/ll-admin-v2/deprecation-workflow": amdModule38,
"@efdigital/ll-admin-v2/lib/color": amdModule39,
"@efdigital/ll-admin-v2/lib/file-icon": amdModule40,
"@efdigital/ll-admin-v2/lib/json-api": amdModule41,
"@efdigital/ll-admin-v2/lib/markdown-toolbar": amdModule42,
"@efdigital/ll-admin-v2/lib/media/media-image-info": amdModule43,
"@efdigital/ll-admin-v2/lib/media/media-image-key": amdModule44,
"@efdigital/ll-admin-v2/lib/media/media-image-path": amdModule45,
"@efdigital/ll-admin-v2/lib/media/models": amdModule46,
"@efdigital/ll-admin-v2/lib/media/paths": amdModule47,
"@efdigital/ll-admin-v2/lib/media/sizes": amdModule48,
"@efdigital/ll-admin-v2/lib/page-manager": amdModule49,
"@efdigital/ll-admin-v2/lib/random-slug": amdModule50,
"@efdigital/ll-admin-v2/lib/type-utils": amdModule51,
"@efdigital/ll-admin-v2/resources/string-array": amdModule52,
"@efdigital/ll-admin-v2/router": amdModule53,
"@efdigital/ll-admin-v2/serializers/application": amdModule54,
"@efdigital/ll-admin-v2/services/ability": amdModule55,
"@efdigital/ll-admin-v2/services/media-images": amdModule56,
"@efdigital/ll-admin-v2/services/session": amdModule57,
"@efdigital/ll-admin-v2/services/store": amdModule58,
"@efdigital/ll-admin-v2/services/va-config": amdModule59,
"@efdigital/ll-admin-v2/services/xapi": amdModule60,
"@efdigital/ll-admin-v2/utils/array": amdModule61,
"@efdigital/ll-admin-v2/utils/files": amdModule62,
"@efdigital/ll-admin-v2/utils/mark-answer": amdModule63,
"@efdigital/ll-admin-v2/utils/random-answer": amdModule64,
"@efdigital/ll-admin-v2/utils/random-values": amdModule65,
"@efdigital/ll-admin-v2/utils/user-groups": amdModule66,
"@efdigital/ll-admin-v2/utils/words": amdModule67,
"@efdigital/ll-admin-v2/initializers/load-bootstrap-config": amdModule68,
"@efdigital/ll-admin-v2/instance-initializers/global-ref-cleanup": amdModule69,
"@efdigital/ll-admin-v2/services/-ensure-registered": amdModule70,
"@efdigital/ll-admin-v2/instance-initializers/gtm": amdModule71,
"@efdigital/ll-admin-v2/services/gtm": amdModule72,
"@efdigital/ll-admin-v2/utils/gtm-page-views": amdModule73,
"@efdigital/ll-admin-v2/utils/gtm-sluggify": amdModule74,
"@efdigital/ll-admin-v2/utils/gtm": amdModule75,
"@efdigital/ll-admin-v2/services/page-title": amdModule76,
"@efdigital/ll-admin-v2/initializers/ember-data": amdModule77,
"@efdigital/ll-admin-v2/transforms/date": amdModule78,
"@efdigital/ll-admin-v2/transforms/number": amdModule79,
"@efdigital/ll-admin-v2/transforms/string": amdModule80,
"@efdigital/ll-admin-v2/transforms/boolean": amdModule81,
"@efdigital/ll-admin-v2/data-adapter": amdModule82,
"@efdigital/ll-admin-v2/services/customization": amdModule83,
"@efdigital/ll-admin-v2/services/picklists": amdModule84,
"@efdigital/ll-admin-v2/services/remote-file": amdModule85,
"@efdigital/ll-admin-v2/services/restrictions": amdModule86,
"@efdigital/ll-admin-v2/templates/application": amdModule87,
"@efdigital/ll-admin-v2/routes/application": amdModule88,
"@efdigital/ll-admin-v2/routes/library/clients/client": amdModule89,
"@efdigital/ll-admin-v2/templates/library/clients/client/edit": amdModule90,
"@efdigital/ll-admin-v2/routes/library/clients/client/edit": amdModule91,
"@efdigital/ll-admin-v2/templates/library/clients/client/edit/branding": amdModule92,
"@efdigital/ll-admin-v2/routes/library/clients/client/edit/branding": amdModule93,
"@efdigital/ll-admin-v2/templates/library/clients/client/edit/content": amdModule94,
"@efdigital/ll-admin-v2/routes/library/clients/client/edit/content": amdModule95,
"@efdigital/ll-admin-v2/routes/library/clients/client/edit/feeds": amdModule96,
"@efdigital/ll-admin-v2/templates/library/clients/client/edit/files": amdModule97,
"@efdigital/ll-admin-v2/routes/library/clients/client/edit/files": amdModule98,
"@efdigital/ll-admin-v2/templates/library/clients/client/edit/general": amdModule99,
"@efdigital/ll-admin-v2/routes/library/clients/client/edit/general": amdModule100,
"@efdigital/ll-admin-v2/templates/library/clients/client/edit/home": amdModule101,
"@efdigital/ll-admin-v2/routes/library/clients/client/edit/home": amdModule102,
"@efdigital/ll-admin-v2/routes/library/clients/client/edit/index": amdModule103,
"@efdigital/ll-admin-v2/routes/library/clients/client/edit/user-groups": amdModule104,
"@efdigital/ll-admin-v2/templates/library/clients/client/edit/users": amdModule105,
"@efdigital/ll-admin-v2/routes/library/clients/client/edit/users": amdModule106,
"@efdigital/ll-admin-v2/templates/library/clients/client/edit/xapi": amdModule107,
"@efdigital/ll-admin-v2/routes/library/clients/client/edit/xapi": amdModule108,
"@efdigital/ll-admin-v2/templates/library/clients/erase": amdModule109,
"@efdigital/ll-admin-v2/routes/library/clients/erase": amdModule110,
"@efdigital/ll-admin-v2/templates/library/clients/import-users": amdModule111,
"@efdigital/ll-admin-v2/routes/library/clients/import-users": amdModule112,
"@efdigital/ll-admin-v2/templates/library/clients/index": amdModule113,
"@efdigital/ll-admin-v2/templates/library/folders": amdModule114,
"@efdigital/ll-admin-v2/routes/library/folders": amdModule115,
"@efdigital/ll-admin-v2/templates/library/folders/file": amdModule116,
"@efdigital/ll-admin-v2/routes/library/folders/file": amdModule117,
"@efdigital/ll-admin-v2/templates/library/folders/new": amdModule118,
"@efdigital/ll-admin-v2/routes/library/folders/new": amdModule119,
"@efdigital/ll-admin-v2/templates/library/folders/upload": amdModule120,
"@efdigital/ll-admin-v2/routes/library/folders/upload": amdModule121,
"@efdigital/ll-admin-v2/templates/library/folders/index": amdModule122,
"@efdigital/ll-admin-v2/templates/library/media-images/edit": amdModule123,
"@efdigital/ll-admin-v2/routes/library/media-images/edit": amdModule124,
"@efdigital/ll-admin-v2/templates/library/media-images/index": amdModule125,
"@efdigital/ll-admin-v2/templates/library/media-images/upload": amdModule126,
"@efdigital/ll-admin-v2/routes/programs/program": amdModule127,
"@efdigital/ll-admin-v2/templates/programs/program/cohort": amdModule128,
"@efdigital/ll-admin-v2/routes/programs/program/cohort": amdModule129,
"@efdigital/ll-admin-v2/templates/programs/program/cohort/calendar/calendar-item": amdModule130,
"@efdigital/ll-admin-v2/routes/programs/program/cohort/calendar/calendar-item": amdModule131,
"@efdigital/ll-admin-v2/templates/programs/program/cohort/calendar/index": amdModule132,
"@efdigital/ll-admin-v2/templates/programs/program/cohort/content": amdModule133,
"@efdigital/ll-admin-v2/routes/programs/program/cohort/content/module": amdModule134,
"@efdigital/ll-admin-v2/templates/programs/program/cohort/content/module/page": amdModule135,
"@efdigital/ll-admin-v2/routes/programs/program/cohort/content/module/page": amdModule136,
"@efdigital/ll-admin-v2/routes/programs/program/cohort/content/module/quiz": amdModule137,
"@efdigital/ll-admin-v2/templates/programs/program/cohort/content/module/index": amdModule138,
"@efdigital/ll-admin-v2/templates/programs/program/cohort/content/page": amdModule139,
"@efdigital/ll-admin-v2/routes/programs/program/cohort/content/page": amdModule140,
"@efdigital/ll-admin-v2/templates/programs/program/cohort/content/quiz": amdModule141,
"@efdigital/ll-admin-v2/routes/programs/program/cohort/content/quiz": amdModule142,
"@efdigital/ll-admin-v2/templates/programs/program/cohort/content/index": amdModule143,
"@efdigital/ll-admin-v2/routes/programs/program/cohort/messages": amdModule144,
"@efdigital/ll-admin-v2/routes/programs/program/cohort/messages/category": amdModule145,
"@efdigital/ll-admin-v2/templates/programs/program/cohort/messages/category/message": amdModule146,
"@efdigital/ll-admin-v2/routes/programs/program/cohort/messages/category/message": amdModule147,
"@efdigital/ll-admin-v2/templates/programs/program/cohort/messages/category/new": amdModule148,
"@efdigital/ll-admin-v2/routes/programs/program/cohort/messages/category/new": amdModule149,
"@efdigital/ll-admin-v2/templates/programs/program/cohort/messages/category/index": amdModule150,
"@efdigital/ll-admin-v2/routes/programs/program/cohort/messages/index": amdModule151,
"@efdigital/ll-admin-v2/templates/programs/program/cohort/participants": amdModule152,
"@efdigital/ll-admin-v2/routes/programs/program/cohort/participants": amdModule153,
"@efdigital/ll-admin-v2/templates/programs/program/cohort/index": amdModule154,
"@efdigital/ll-admin-v2/templates/programs/program/index": amdModule155,
"@efdigital/ll-admin-v2/templates/programs/index": amdModule156,
"@efdigital/ll-admin-v2/templates/bootstrap": amdModule157,
"@efdigital/ll-admin-v2/templates/index": amdModule158,
"@efdigital/ll-admin-v2/templates/resource": amdModule159,
  },
  exportFastbootModules
);
